import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-added',
  templateUrl: './has-sub-settings.component.html'
})
export class HasSubSettingsComponent {
  constructor(public modal: NgbActiveModal) {}
}